export default __webpack_public_path__ + "static/media/sequelize-svgrepo-com.c3c0236f.svg";